import React, { useState, useEffect } from "react";
import { DroneImageProps } from "../../../types";
import { UserCircleIcon } from "@heroicons/react/solid";
import { useSignedUrl } from "../../../../../../../hooks/use_signed_url";

const DroneImage: React.FC<DroneImageProps> = React.memo(({ imageUrl, droneName }) => {
  const signedUrl = useSignedUrl(imageUrl);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  
  // Reset states when image URL changes
  useEffect(() => {
    setImageLoaded(false);
    setImageError(false);
  }, [imageUrl, signedUrl, droneName]);

  // Show the fallback icon only when we have no valid image to display
  const showFallbackIcon = !signedUrl || imageError || !imageLoaded;
  

  return (
    <div 
      className="w-full h-48 bg-gray-200 flex items-center justify-center rounded-2xl overflow-hidden relative"
      style={{ transform: 'translateZ(0)' }}
    >
      {/* Fallback icon shown at beginning or on error */}
      {showFallbackIcon && (
        <div className="absolute inset-0 flex items-center justify-center z-10">
          <UserCircleIcon className="w-16 h-16 text-gray-500" />
        </div>
      )}
      
      {/* Actual image with opacity transition */}
      {signedUrl && !imageError && (
        <img
          src={signedUrl}
          alt={droneName || "Drone"}
          className={`w-full h-full object-cover transition-opacity duration-300 z-20 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
          loading="lazy"
          style={{ maxWidth: '400px', maxHeight: '192px' }}
          onLoad={() => {
            setImageLoaded(true);
          }}
          onError={() => {
            setImageError(true);
          }}
        />
      )}
    </div>
  );
});

export default DroneImage;
